import React, { forwardRef, useCallback, useImperativeHandle, useState } from "react";

import captchaImg1 from "../captcha/assets/captcha_1.png";
import captchaImg2 from "../captcha/assets/captcha_2.png";
import captchaImg3 from "../captcha/assets/captcha_3.png";
import captchaImg4 from "../captcha/assets/captcha_4.png";
import captchaImg5 from "../captcha/assets/captcha_5.png";
import captchaImg6 from "../captcha/assets/captcha_6.png";
import captchaImg7 from "../captcha/assets/captcha_7.png";
import captchaImg8 from "../captcha/assets/captcha_8.png";
import captchaImg9 from "../captcha/assets/captcha_9.png";
import captchaImg10 from "../captcha/assets/captcha_10.png";

import alphaImg1 from "../captcha/assets/alphabet_captcha/captcha_1.png";
import alphaImg2 from "../captcha/assets/alphabet_captcha/captcha_2.png";
import alphaImg3 from "../captcha/assets/alphabet_captcha/captcha_3.png";
import alphaImg4 from "../captcha/assets/alphabet_captcha/captcha_4.png";
import alphaImg5 from "../captcha/assets/alphabet_captcha/captcha_5.png";
import alphaImg6 from "../captcha/assets/alphabet_captcha/captcha_6.png";
import alphaImg7 from "../captcha/assets/alphabet_captcha/captcha_7.png";
import alphaImg8 from "../captcha/assets/alphabet_captcha/captcha_8.png";
import alphaImg9 from "../captcha/assets/alphabet_captcha/captcha_9.png";
import alphaImg10 from "../captcha/assets/alphabet_captcha/captcha_10.png";

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

const CHALLENGES_MATH = [
  { img: captchaImg1, answer: "25" },
  { img: captchaImg2, answer: "19" },
  { img: captchaImg3, answer: "23" },
  { img: captchaImg4, answer: "17" },
  { img: captchaImg5, answer: "16" },
  { img: captchaImg6, answer: "24" },
  { img: captchaImg7, answer: "24" },
  { img: captchaImg8, answer: "27" },
  { img: captchaImg9, answer: "28" },
  { img: captchaImg10, answer: "28" },
];

const CHALLENGES_ALPHABET = [
  { img: alphaImg1, answer: "bheqzf" },
  { img: alphaImg2, answer: "ppybb" },
  { img: alphaImg3, answer: "qntyxp" },
  { img: alphaImg4, answer: "g9rqby" },
  { img: alphaImg5, answer: "hydftg" },
  { img: alphaImg6, answer: "dfg8pi" },
  { img: alphaImg7, answer: "zr7dej" },
  { img: alphaImg8, answer: "ebxqnq" },
  { img: alphaImg9, answer: "7bcjd7" },
  { img: alphaImg10, answer: "numjh9" },
];

const CHALLENGE_SETS = {
  math: CHALLENGES_MATH,
  alphabet: CHALLENGES_ALPHABET,
};

function makeChallenge(type) {
  return pick(CHALLENGE_SETS[type] || CHALLENGES_MATH);
}

const Captcha = forwardRef(function Captcha(
  { answer = "", onVerify, className, type = "math" },
  ref
) {
  const [challenge, setChallenge] = useState(() => makeChallenge(type));

  const regenerate = useCallback(() => setChallenge(makeChallenge(type)), [type]);

  useImperativeHandle(
    ref,
    () => ({
      verify: () => {
        const typed = String(answer).trim().toLowerCase();
        const ok = typed !== "" && typed === challenge.answer;
        onVerify?.(ok);
        if (!ok) regenerate();
        return ok;
      },
      reset: regenerate,
    }),
    [answer, challenge, onVerify, regenerate]
  );

  return (
    <img
      src={challenge.img}
      alt="Captcha challenge"
      title="Captcha challenge"
      className={className}
      style={{ display: "block", width: "100%", height: "100%", objectFit: "contain" }}
    />
  );
});

export default Captcha;
